import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MassEmail } from '../mass-email.model';

@Component({
  selector: 'app-send-emails-warning',
  templateUrl: './send-emails-warning.component.html'
})
export class SendEmailsWarningComponent implements OnInit {
  massEmail: MassEmail;
  constructor(
    public sendEmailsWarningDialogRef: MatDialogRef<SendEmailsWarningComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.massEmail = this.data.massEmailObj;
  }
  sendAnywayClick() {
    this.sendEmailsWarningDialogRef.close('Send Anyway Was Clicked');
  }
  cancelClick() {
    this.sendEmailsWarningDialogRef.close('Cancel Was Clicked');
  }
}
